import { useEffect, useRef } from "react"
import { useRouterState } from "@tanstack/react-router"

import {
  findSelectedTabOrPageStart,
  focusPageStartWhenVisible,
  MAIN_ID,
} from "@src/utils/focusPageStart"

const isFocusInsideDialog = () =>
  Boolean(document.activeElement?.closest('[role="dialog"]'))

export const useFocusPageOnNavigate = () => {
  const pathname = useRouterState({
    select: (state) => state.resolvedLocation.pathname,
  })
  const previousPathname = useRef(pathname)
  const lastFocusedWasTab = useRef(false)

  useEffect(() => {
    const rememberFocus = (event: FocusEvent) => {
      const target = event.target
      lastFocusedWasTab.current =
        target instanceof HTMLElement &&
        target.getAttribute("role") === "tab" &&
        Boolean(target.closest(`#${MAIN_ID}`))
    }
    document.addEventListener("focusin", rememberFocus)
    return () => document.removeEventListener("focusin", rememberFocus)
  }, [])

  useEffect(() => {
    if (previousPathname.current === pathname) return
    previousPathname.current = pathname

    if (isFocusInsideDialog()) return
    focusPageStartWhenVisible({
      preventScroll: true,
      timeoutMs: 3000,
      findTarget: lastFocusedWasTab.current ? findSelectedTabOrPageStart : undefined,
    })
  }, [pathname])
}
